import dayjs, { Dayjs } from "dayjs";

const isChanged =  (oldVal, newVal) => {
    try {
        if(oldVal == null && (newVal == null || newVal == '')) {
            return false;
        }

        return JSON.stringify(oldVal) != JSON.stringify(newVal);
    }
    catch (e) {
        return false
    }
}

class ChangeTracker {
    changes: any

    constructor(observables, callBackFn) {
        this.changes = {}
        observables.forEach((observable, index) => {
            let waitInitialValue = false; // helps for our ddls that are strings initially, but then update to ids (numbers)
            let initialValue;
            let _observable = ko.observable();

            if(typeof observable === 'object' && Object.keys(observable).length) {
                waitInitialValue = observable['waitInitialValue'] ?? false;
                _observable = observable['observable'];
                initialValue = observable['initialValue'] ?? _observable();
            }
            else {
                _observable = observable;
                initialValue = _observable();
            }
            
            if(typeof initialValue === 'string') {
                initialValue = initialValue.toLowerCase();
            }

            if(typeof initialValue === 'object' && initialValue instanceof dayjs) {
                initialValue = (initialValue as Dayjs).format('YYYY-MM-DDtHH:mm:ssZ');
            }

            this.changes[index] = { initialValue, currentValue: initialValue };
            this.changes[index].isDirty = () => this.isDirty(index);
            
            _observable.subscribe((newValue) => {
                if(waitInitialValue) {
                    initialValue = newValue;
                    waitInitialValue = false;
                    return;
                }

                if(typeof newValue === 'string') {
                    newValue = newValue.toLowerCase();
                }

                if(typeof newValue === 'object' && newValue instanceof dayjs) {
                    newValue = (newValue as Dayjs).format('YYYY-MM-DDtHH:mm:ssZ')
                }
    
                this.changes[index].currentValue = newValue;
                
                if(callBackFn) {
                    callBackFn(this.changes[index], index, this.changes);
                }
            });
        });
    }

    isAnyDirty() {
        return Object.keys(this.changes).some(key => this.isDirty(key));
    }

    isDirty(index) {
        const entry = this.changes[index];
        if (!entry) {
            return false;
        }

        return isChanged(entry.initialValue, entry.currentValue);
    }
    reset() {
        Object.keys(this.changes).forEach(key => {
            this.changes[key].currentValue = this.changes[key].initialValue;
        });
    }
}

export default function koChangeTracker(observables, callBackFn) {
    return new ChangeTracker(observables, callBackFn);
}